export default {
  components: {
    styleOverrides: {
      root: ({ ownerState, theme }: { ownerState: any; theme: any }) => ({
        '&.error': {
          color: theme.palette.error.main
        },
        '&.error + .MuiFormControlLabel-label': {
          color: theme.palette.error.main
        }
      })
    }
  }
};
